module.exports = __webpack_public_path__ + "static/img/samajuri (13).c1bd881.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/samajuri/samajuri (13).jpg
// module id = 0DFF
// module chunks = 0